import { compose } from "recompose";

import { protectedComponentHoc } from "../../components/ProtectedComponent";
import PolicyFilesComponent from "./component";

export const PolicyFiles = compose(protectedComponentHoc)(PolicyFilesComponent);
